import React, { useEffect } from 'react';
import {
  Redirect,
  Switch,
  useLocation,
} from 'react-router-dom';
import {
  routes,
} from 'consts';
import ChangePassword from 'pages/changePassword';
import Dashboard from 'pages/Dashboard';
import EnergyCommunity from 'pages/EnergyCommunity';
import { generateRoutes } from 'utils';

import Navbar from 'components/navbar/Navbar';

const appRoutes = [
  {
    title: 'Dashboard',
    key: 'dashboard',
    link: routes.dashboard.root,
    component: <Dashboard />,
    exact: true,
  },
  {
    title: 'EnergyCommunity',
    key: 'energyCommunity',
    link: routes.energyCommunity.root,
    component: <EnergyCommunity />,
    exact: true,
  },
  {
    title: 'changePassword',
    key: 'changePassword',
    link: routes.changePassword.root,
    component: <ChangePassword />,
  },
];

const Router = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, [location]);

  return (
    <>
      <Navbar />
      <Switch>
        {generateRoutes(appRoutes, [
          '/',
          '/energy-community',
          '/change-password',
        ])}
        {/* <Redirect to={isRouteAvailable(routes.dashboard.root) ? routes.dashboard.root : routes.energyCommunity.root} /> */}
        <Redirect to={routes.dashboard.root} />
      </Switch>
    </>
  );
};

export default Router;
